import { createRoute, useParams } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const ExerciseDetailPage = lazy(async () => {
  const m = await import("@/features/gym/components/exercise-detail-page");
  return { default: m.ExerciseDetailPage };
});

function ExerciseDetailRoutePage() {
  const params = useParams({ from: "/_app/exercises/$exerciseId" });
  return (
    <Suspense fallback={null}>
      <ExerciseDetailPage exerciseId={() => params().exerciseId} />
    </Suspense>
  );
}

export const exerciseDetailRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/exercises/$exerciseId",
  component: ExerciseDetailRoutePage,
});
